<template>
  <div>
    <vue-skeleton-loader
        v-if="setup_intent_loading"
        :height="60"
        :width="672"
        animation="wave"
        class="w-full mt-3"
        type="rect"
    />
    <vue-skeleton-loader
        v-if="setup_intent_loading"
        :height="60"
        :width="672"
        animation="wave"
        class="w-full mt-3"
        type="rect"
    />
    <vue-skeleton-loader
        v-if="setup_intent_loading"
        :height="60"
        :width="672"
        animation="wave"
        class="w-full mt-3"
        type="rect"
    />
    <p class="text-xl my-5 text-red-700"> {{ error.message }}</p>
    <div id="payment-element" ref="payment-element"></div>
    <div>
      <div v-if="!setup_intent_loading" class="flex justify-end">
        <button
            v-if="adding_payment_method"
            class="btn btn-primary font-semibold rounded-lg mt-12 px-10 min-w-10 w-full md:w-auto"
        >
          <spinner class="mx-auto"/>
        </button>
        <button
            v-else
            class="btn btn-primary font-semibold rounded-lg mt-12 px-10 min-w-10 w-full md:w-auto"
            @click="addPaymentMethod"
        >
          <span>Add Payment Method</span>
        </button>

      </div>
    </div>

  </div>
</template>

<script>
import ApiV1 from '@/api/api_v1.0'
import Spinner from '@/components/common/Spinner.vue'

export default {
  name      : 'SetupIntent',
  components: { Spinner },
  data () {
    return {
      confirmParams        : {
        return_url: '', // success url
      },
      elements             : null,
      setup_intent_loading : false,
      adding_payment_method: false,
      error                : {
        message: ''
      }
    }
  },
  computed: {
    order () {
      return this.$store.state.currentEditingOrder
    },
  },
  mounted () {
    this.setupIntent()
  },
  methods: {
    async addPaymentMethod () {
      this.adding_payment_method = true
      let response = await this.$stripe.confirmSetup({
        elements     : this.elements,
        confirmParams: this.confirmParams
      })
      this.error = response.error
      this.adding_payment_method = false
    },
    async setupIntent () {
      this.setup_intent_loading = true
      let response = await ApiV1.setupIntent(this.order.uuid)
      let clientSecret = response.data.client_secret
      this.confirmParams.return_url = response.data.return_url
      const elements = this.$stripe.elements({ clientSecret, locale: 'en' })
      const paymentElement = elements.create('payment', {
        fields        : {
          billingDetails: {
            address: {
              country: 'auto'
            }
          }
        },
        hidePostalCode: false,
      })
      paymentElement.mount('#payment-element')
      this.elements = elements
      this.setup_intent_loading = false
    },
  }
}
</script>

<style scoped>

</style>